"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnHeadersContext = void 0;
var React = require("react");
/** Whether column headers are shown, i.e. as the first row of the grid. */
exports.ColumnHeadersContext = React.createContext(true);
exports.ColumnHeadersContext.displayName = 'DataGridColumnHeadersContext';
//# sourceMappingURL=Column.js.map